// =============================================================================
// Dashboard Sidebar Nav Config
// =============================================================================
// Defines the navigation items shown in the left sidebar of the dashboard.
// Organised into three sections: Workspace, Tools, and Account.
//
// Items marked with href: '/path?fresh=1' or similar always start fresh.
// Items pointing to placeholder routes (Exports, Chat, etc.) will 404 until
// those pages are built — add routes in src/routes/sections/ when ready.
//
// To add a new nav item:
//   1. Add an entry in the relevant subheader items array below
//   2. Register the route in src/routes/sections/
//   3. Add the path constant to src/routes/paths.ts
//
// Related files:
//   src/layouts/dashboard/nav-vertical.tsx  → renders this data as the sidebar
//   src/layouts/nav-config-account.tsx      → account drawer menu (top-right avatar)
//   src/routes/paths.ts                     → path constants
// =============================================================================

import type { NavSectionProps } from 'src/components/nav-section';

import HistoryIcon from '@mui/icons-material/History';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  /**
   * Workspace
   */
  {
    subheader: 'Workspace',
    items: [
      {
        title: 'Dashboard',
        path: paths.dashboard.root,
        icon: <HomeRoundedIcon />,
      },
      {
        title: 'New CMA',
        path: '/new-cma?fresh=1',
        icon: <AddCircleOutlineIcon />,
      },
      {
        title: 'History',
        path: paths.cmaHistory.root,
        icon: <HistoryIcon />,
      },
      {
        title: 'Exports',
        path: '/exports',
        icon: <FileUploadOutlinedIcon />,
      },
    ],
  },
  /**
   * Tools
   */
  {
    subheader: 'Tools',
    items: [
      {
        title: 'Chat Assistant',
        path: '/chat',
        icon: <ChatBubbleOutlineIcon />,
      },
      {
        title: 'Market Trends',
        path: '/market-trends',
        icon: <TrendingUpIcon />,
      },
      {
        title: 'Branding',
        path: '/branding',
        icon: <BrushOutlinedIcon />,
      },
    ],
  },
  /**
   * Account
   */
  {
    subheader: 'Account',
    items: [
      {
        title: 'Users',
        path: paths.users.root,
        icon: <PeopleRoundedIcon />,
      },
    ],
  },
];
